import Datepicker from '../DatePicker';

//@ts-ignore
import { tw } from '@careinfo/tailwind';
const DateRangePicker = (props: any) => {
  const { label, setValue, name, getValues, setDate, disabled = false } = props;

  const handleValueChange = (newValue: any) => {
    if (newValue?.startDate && newValue.endDate) {
      const startDate = new Date(`${newValue?.startDate}T00:00:00`);
      const formattedStartDate = startDate.toISOString();
      const endDate = new Date(`${newValue?.endDate}T23:59:00`);
      const formattedEndDate = endDate.toISOString();
      setValue(name, `${newValue?.startDate},${newValue?.endDate}`);
      setDate(`${formattedStartDate},${formattedEndDate}`);
    } else {
      setValue(name, '');
      setDate('');
    }
  };

  return (
    <div className={tw`mt-2`}>
      <label htmlFor={name} className=''>
        {label}
      </label>
      <div className={tw`mt-[12px]`}>
        <Datepicker
          inputId={name}
          disabled={disabled}
          inputClassName={tw`focus:outline-none bg-[#EEF5F4] w-full p-2`}
          popoverDirection='down'
          value={{
            startDate: getValues()?.[name]?.split(',')?.[0] ?? null,
            endDate: getValues()?.[name]?.split(',')?.[1] ?? null,
          }}
          primaryColor={'pink'}
          onChange={handleValueChange}
          showShortcuts={true}
        />
      </div>
    </div>
  );
};

export default DateRangePicker;
